import React, { useState, useEffect, useContext } from "react";
import { TrendingCoinsData } from "../services/coinGeckoAPI";
import { CurrencyContext } from "../services/currencyContext";
import { Image, Carousel, Space } from "antd";
import getSymbolFromCurrency from "currency-symbol-map";

const Carosal = () => {
  const [cryptoList, setCryptoList] = useState([]);

  const { currencyState } = useContext(CurrencyContext);

  const [currency] = currencyState;

  const currencySymbol = getSymbolFromCurrency(currency.toUpperCase());

  useEffect(() => {
    TrendingCoinsData(currency, setCryptoList);
  }, [currency]);

  const items = cryptoList?.map((item) => {
    return (
      <img
        src={item.image}
        alt={item.name}
        style={{ width: "70px", height: "70px" }}
      />
    );
  });

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
  };

  return (
    <>
      <div style={{ padding: "60px" }}>
        <Carousel slidesToShow={7} autoplay dots={false}>
          {cryptoList?.map((item, key) => {
            return (
              <>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Image
                    key={item.id}
                    src={item.image}
                    alt={item.name}
                    height="40px"
                    width="40px"
                    style={{ marginLeft: "25px", marginRight: "25px" }}
                  />
                  <div
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      marginLeft: "25px",
                    }}
                  >
                    <Space>
                      <span style={{ fontStyle: "bold", fontWeight: "bold" }}>
                        {" "}
                        {item.symbol.toUpperCase()}
                      </span>
                      <span>
                        {item?.price_change_percentage_24h?.toFixed(2)}%
                      </span>
                    </Space>
                  </div>

                  <div>
                    <span
                      style={{
                        fontSize: "18px",
                        alignSelf: "center",
                        justifyContent: "center",
                        marginLeft: "25px",
                        fontFamily: "Helvet",
                      }}
                    >
                      {currencySymbol} {item.current_price}
                    </span>
                  </div>
                </div>
              </>
            );
          })}
        </Carousel>
      </div>
    </>
  );
};

export default Carosal;
